import { formatPhone, formatPhoneLink } from '../../../Utility/phoneNumberFormat';
import { getOrderDetail } from './OrderSlice';
import { makeCall } from '../../../Utility/makeCallText';
import { usdFormat } from '../../../Utility/usdFormat';
import Loading from '../../../Components/Loading';
import logo from '../../../assets/Hirschnow.png';
import { useAppSelector } from '../../../hooks';
import { OrderDetails } from '../../../Types/OrderDetail';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useNavigation } from 'react-router-dom';
import { Order } from '../../../Types/Order';
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { Divider } from '@mui/material';
import CRMEntryModal from '../CRM/CRMEntryModal';
import { Add } from '@mui/icons-material';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../firebase';

const OrderDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const item = location.state?.item as Order;
    const data = useAppSelector<OrderDetails>(getOrderDetail);
    const loading = useAppSelector((state) => state.orders.loading);
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    // const [dueBy, setDueBy] = useState<string | null>('');

    // useEffect(() => {
    //     console.log(data.reqTime);
    //     if (!data?.reqTime) {
    //         setDueBy(null);
    //     };
    //     const dueDate = new Date(data.reqTime);
    //     setDueBy(dateFormatter.format(dueDate));
    // }, [data?.reqTime]);

    const onClose = () => {
        setModalOpen(false);
    };

    const handleCrmModal = async () => {
        setModalOpen(true);
        logEvent(analytics, 'crm_modal_web', {
            name: 'Customer CRM Modal',
            description: 'User used Customer CRM Modal'
        });
    }

    const dateFormatter = new Intl.DateTimeFormat('en-US', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });

    const dueBy = data?.reqTime
        ? (() => {
            const date = new Date(data.reqTime);
            return isNaN(date.getTime())
                ? null
                : dateFormatter.format(date);
        })()
        : null;

    const readyAt =
        data?.readyTime && !isNaN(new Date(data.readyTime).getTime())
            ? new Date(data.readyTime).toLocaleTimeString('en-us', { timeStyle: 'short' })
            : null;

    return (
        <div>
            <div 
                style={{ 
                    flexDirection: 'row', 
                    textAlign: 'start',
                    paddingBlockStart: '10px',
                    paddingBlockEnd: '10px',
                    position: 'sticky',
                    top: 60,
                    zIndex: 1000,
                }}
                className="bg-light w-100"
            >
                <Container>
                    <Button
                        className="mainButton w-25 fw-bold"
                        onClick={handleCrmModal}
                    >
                        <Add />
                        <span className="itemName">New CRM</span>
                    </Button>
                </Container>
            </div>
            {loading ? (<Loading />) 
            :(
                <div
                    style={{ padding: 10 }}
                >
                    <Row style={{ paddingInline: 20 }}>
                        <Col xs={12} md={6} lg={6}>
                            <Card>
                                <span className='headerText'>Order Information</span>
                                <Divider style={{ borderColor: 'gray'}} variant='middle'/>
                                <CardBody className='d-flex gap-5'>
                                    <div className='text-start'>
                                        <span className='itemName d-block'>Order #</span>
                                        <span className='itemName d-block'>PO</span>
                                        <span className='itemName d-block'>Order Total</span>
                                        <span className='itemName d-block'>Branch</span>
                                        <span className='itemName d-block'>Branch #</span>
                                        <span className='itemName d-block'>Sales Person</span>
                                        <span className='itemName d-block'>Sales Person #</span>
                                        <span className='itemName d-block'>Readied By</span>
                                        {dueBy && <span className='itemName d-block'>Due By</span>}
                                        {readyAt && <span className='itemName d-block'>Ready At</span>}
                                        <span className='itemName d-block'>Status</span>
                                    </div>
                                    <div className='text-start'>
                                        <span className='itemDescription d-block'>{item.id}</span>
                                        <span className='itemDescription d-block'>{item.po}</span>
                                        <span className='itemDescription d-block'>{usdFormat.format(item.orderAmount)}</span>
                                        <span className='itemDescription d-block'>{item.branchName}</span>
                                        <a 
                                            onClick={() => makeCall(formatPhoneLink(item.branchPhone))}
                                            style={{ color: '#1a73e8', textDecoration: 'underline', cursor: 'pointer' }}
                                        >
                                            {formatPhone(item.branchPhone)}
                                        </a>
                                        <span className='itemDescription d-block'>{data.salesName}</span>
                                        <span>{formatPhone(data.salesPhone)}</span>
                                        <span className='itemDescription d-block'>{data.filledBy}</span>
                                        {dueBy && <span className='itemDescription d-block'>{dueBy}</span>}
                                        {readyAt && <span className='itemDescription d-block'>{readyAt === 'Invalid Date' ? ' ' : readyAt}</span>}
                                        <span style={
                                            item.statusMessage === 'Ready For Pickup'
                                            ? { color: 'green', fontWeight: 'bold', }
                                            : item.statusMessage === 'Late'
                                            ? { color: 'red', fontWeight: 'bold', }
                                            : { fontWeight: 'bold', }
                                            }>{item.statusMessage}</span>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs={12} md={6} lg={6}>
                            <Card>
                                <span className='headerText'>Customer Information</span>
                                <Divider style={{ borderColor: 'gray'}} variant='middle'/>
                                <CardBody>
                                    <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'start', gap: 10 }}>
                                        <div>
                                            <span className='itemName d-block'>Cust.</span>
                                            <span className='itemName d-block'>Cust. #</span>
                                            <span className='itemName d-block'>Cust. Phone #</span>
                                        </div>
                                        <div>
                                            <span className='itemDescription d-block'>{item.customerName}</span>
                                            <span className='itemDescription d-block'>{item.customerId}</span>
                                            <a 
                                                onClick={() => makeCall(formatPhoneLink(data.customerPhone))}
                                                style={{ color: '#1a73e8', textDecoration: 'underline', cursor: 'pointer' }}
                                            >
                                                {formatPhone(data.customerPhone)}
                                            </a>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col>
                            <Card 
                                className='mt-2'
                            >
                                <span className='headerText'>Products</span>
                                <Divider style={{ borderColor: 'gray'}} variant='middle'/>
                                <CardBody>

                                    {data.products.map((item) => {
                                        const photoUri = item?.details?.[0]?.IMAGES?.[0]?.PHOTO;
                                        
                                        return (    
                                            <Card
                                                onClick={() => navigate(`/ProductDetail/${item.id}`, { state: { item } })}
                                                key={item.id}
                                                style={{ userSelect: 'none', cursor: 'pointer' }}
                                            >
                                                <CardBody 
                                                    style={{ display: 'flex', flexDirection: 'row', textAlign: 'start'}}
                                                >
                                                    <div style={{ alignSelf: 'center', marginRight: 20 }}>
                                                        {!photoUri ? (
                                                            <img 
                                                                style={{ justifyContent: 'center', width: 100, height: 100 }}
                                                                src={logo}
                                                            />
                                                        ) : (
                                                            <img 
                                                                style={{ justifyContent: 'center', width: 100, height: 100 }}
                                                                src={photoUri}
                                                                // PlaceholderContent={<ActivityIndicator size='large'/>}
                                                            />
                                                        )}
                                                    </div>
                                                    <div 
                                                        className='text-start px-2'
                                                    >
                                                        <span className='fw-bold d-block'>Product:</span>
                                                        <span className='fw-bold d-block'>SKU:</span>
                                                        <span className='fw-bold d-block'>Qty:</span>
                                                        <span className='fw-bold d-block'>Price:</span>
                                                    </div>
                                                    <div 
                                                        className='text-start'
                                                    >
                                                        <span className='itemDescription d-block'>{item.id}</span>
                                                        <span className='itemDescription d-block'>{item.desc}</span>
                                                        <span className='itemDescription d-block'>{item.qty}</span>
                                                        <span className='itemDescription d-block'>{usdFormat.format(item.amount)}</span>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        )
                                    })}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            )}
            {modalOpen &&
                <CRMEntryModal
                    visible={modalOpen}
                    onClose={onClose}
                    customerID={item.id}
                />
            }
        </div>
    )
};

export default OrderDetail;